<div class="wrapper">
  <div class="notification-pane">
    @for (notification of notifications; track notification) {
      <app-notification
        (onClose)="closeNotification($event)"
        [notification]="notification"
      >
        {{ notification.message }}
      </app-notification>
    }
  </div>
</div>
